var exports = {
  "HM": "xa15a2ab7--e1033a--btn",
  "xk": "xa15a2ab7--e1033a--btn--dark",
  "Kk": "xa15a2ab7--e1033a--icon",
  "UE": "xa15a2ab7--e1033a--arrow",
  "Te": "xa15a2ab7--e1033a--texts",
};

module.exports = exports;
